import {setServer} from "@/utils/axios";
const request = setServer();

// 查询用户下拉
export function getUserRefer(data) {
  return request({
    url: '/sys/user/refer',
    method: 'post',
    data: data
  })
}
// 查询用户列表
export function getUserList(data) {
  return request({
    url: '/sys/user/v2/list',
    method: 'post',
    data: data
  })
}

// 查询用户详细
export function getUserDetail(data) {
  return request({
    url: '/sys/user/get',
    method: 'post',
    data:data
  })
}

// 新增用户
export function addUser(data) {
  return request({
    url: '/sys/user/add',
    method: 'post',
    data: data
  })
}

// 修改用户
export function updateUser(data) {
  return request({
    url: '/sys/user/update',
    method: 'post',
    data: data
  })
}

// 删除用户
export function deleteUser(data) {
  return request({
    url: '/sys/user/del',
    method: 'post',
    data: data
  })
}

// 用户绑定账号
export function bindUserAccount(data) {
  return request({
    url: '/sys/user/account/bind',
    method: 'post',
    data:data
  })
}

// 修改用户状态
export function setUserStatus(data) {
  return request({
    url: '/sys/user/enable',
    method: 'post',
    data:data
  })
}

// 用户绑定角色
export function bindUserRole(data) {
  return request({
    url: '/sys/user/bind-role',
    method: 'post',
    data:data
  })
}

// 用户绑定角色回显
export function getUserRoleIds(data) {
  return request({
    url: '/sys/user/bind-echo',
    method: 'post',
    data:data
  })
}

// 子级用户列表回显
export function getUserBindChildEcho(data) {
  return request({
    url: '/user/relation/bind/child/echo',
    method: 'post',
    data:data
  })
}

// 绑定子级
export function setUserBindChild(data) {
  return request({
    url: '/user/relation/bind/child',
    method: 'post',
    data:data
  })
}

// 子级用户列表
export function getUserBindChildList(data) {
  return request({
    url: '/user/relation/list/bind/child',
    method: 'post',
    data:data
  })
}

// 父级用户列表回显
export function getUserBindParentEcho(data) {
  return request({
    url: '/user/relation/bind/parent/echo',
    method: 'post',
    data:data
  })
}

// 绑定父级
export function setUserBindParent(data) {
  return request({
    url: '/user/relation/bind/parent',
    method: 'post',
    data:data
  })
}

// 绑定父级 -- 销售
export function setSellUserBindParent(data) {
  return request({
    url: '/user/relation/sell/bind/parent',
    method: 'post',
    data:data
  })
}

// 父级用户列表
export function getUserBindParentList(data) {
  return request({
    url: '/user/relation/list/bind/parent',
    method: 'post',
    data:data
  })
}

// 父级用户列表---销售
export function getSellUserBindParentList(data) {
  return request({
    url: '/user/relation/sell/list/bind/parent',
    method: 'post',
    data:data
  })
}
// 列表查询---销售专用
export function getUserSellList(data) {
  return request({
    url: '/sys/user/v2/sell/list',
    method: 'post',
    data:data
  })
}
// 新增账号--销售专用
export function addUserSellAccount(data) {
  return request({
    url: '/user/v2/sell/add',
    method: 'post',
    data:data
  })
}

// 绑定的客户回显
export function getUserBindCustomerEcho(data) {
  return request({
    url: 'sys/user/v2/bind/customer/echo',
    method: 'post',
    data:data
  })
}

// 销售绑定客户
export function doBindCustomerToSell(data) {
  return request({
    url: '/sys/user/v2/sell/bind/customer',
    method: 'post',
    data:data
  })
}

// 子级绑定客户
export function doBindCustomerToUserChild(data) {
  return request({
    url: '/sys/user/v2/child/bind/customer',
    method: 'post',
    data:data
  })
}

/**
 * 用户下拉
 * @param {object} data
 * @param {number} data.roleType  角色类型 1:销售 2:代理商 3:客户
 * @param {string} data.name  名称
 * @returns {Promise}
 */
export function getUserV2Refer(data) {
  return request({
    url: '/sys/user/v2/refer',
    method: 'post',
    data:data
  })
}

/**
 * 修改用户消息配置
 */
export function setUserMsgConfig(data) {
  return request({
    url: '/sys/user/v2/update/notice/config',
    method: 'post',
    data:data
  })
}

/**
 * 获取用户消息配置
 */
export function getUserMsgConfig(data) {
  return request({
    url: '/sys/user/v2/get/notice/config',
    method: 'post',
    data:data
  })
}

/**
 * 新增账号
 */
export function addV2User(data) {
  return request({
    url: '/user/v2/add',
    method: 'post',
    data:data
  })
}

// 开关MFA状态
export function updateCustomerUserMfa(data) {
  return request({
    url: 'sys/user/v2/update/mfa',
    method: 'post',
    data
  })
}
// 校验mfa是否存在
export function checkUserMfaExist(data) {
  return request({
    url: '/sys/user/v2/check/mfa' ,
    method: 'post',
    data:data
  })
}

// 开启mfa，校验maf验证码是否正确
export function checkUserMfaCode(data) {
  return request({
    url: '/sys/user/v2/check/code' ,
    method: 'post',
    data:data
  })
}
// mfa，首次验证验证码
export function bindUserMfaCode(data) {
  return request({
    url: '/sys/user/v2/bind/code' ,
    method: 'post',
    data:data
  })
}
// mfa，绑定设备名称
export function bindUserMfaDeviceName(data) {
  return request({
    url: '/sys/user/v2/bind/name' ,
    method: 'post',
    data:data
  })
}
// mfa，第二次验证验证码
export function regUserMfaCode(data) {
  return request({
    url: '/sys/user/v2/reg/code' ,
    method: 'post',
    data:data
  })
}
// 技术人员绑定销售
export function bindTechnicianSell(data) {
  return request({
    url: '/sys/user/v2/technician/bind/sell' ,
    method: 'post',
    data:data
  })
}
//回显技术人员绑定销售
export function getTechnicianBindSellEcho(data) {
  return request({
    url: '/sys/user/v2/echo/technician/bind/sell' ,
    method: 'post',
    data:data
  })
}

//回显用户绑定权限
export function getUserBindPermissionIds(data) {
  return request({
    url: '/sys/user/bind/permission-echo' ,
    method: 'post',
    data:data
  })
}

//用户绑定权限
export function setUserBindPermission(data) {
  return request({
    url: '/sys/user/bind-permission' ,
    method: 'post',
    data:data
  })
}


//回显用户绑定目录
export function getUserBindMenuIds(data) {
  return request({
    url: '/sys/user/bind/directory-echo' ,
    method: 'post',
    data:data
  })
}

//用户绑定目录
export function setUserBindMenu(data) {
  return request({
    url: '/sys/user/bind-directory' ,
    method: 'post',
    data:data
  })
}




// WEBPACK FOOTER //
// ./src/api/sys/user.js